import _ from 'lodash';
import axios from 'axios';

// var ax = axios.create({
//     baseURL: process.env.VUE_APP_BACKEND_ENDPOINT,
//     headers: {
//         'x-api-key': process.env.VUE_APP_X_API_KEY
//     }
// });

var ApiCreativeProduction = function() {

    // CREATIVES
     /**
     * returns list of creatives
     */
    this.getCreativeList = () => {
        return new Promise((resolve, reject) => {
            axios.get(`${process.env.VUE_APP_ENDPOINT_CREATIVE_LIST}`)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
 
    /**
     * returns list of Airtory creatives
     */
    this.getCreativeListReadyForTraffic = () => {
        return new Promise((resolve, reject) => {
            axios.get(`${process.env.VUE_APP_ENDPOINT_CREATIVE_LIST_TRAFFIC}`)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    /**
     * Get a creative by id
     * @param {number} id - Creative ID
     */
    this.getCreativeById = (id) => {
        return new Promise((resolve, reject) => {
            axios.get(`${process.env.VUE_APP_ENDPOINT_CREATIVE_BY_ID}${id}`)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    /**
     * create a creative
     * @param {number} data - Creative Data to be inserted
     */
    this.createCreative = (data) => {
        return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_ENDPOINT_CREATIVE_CREATE}`, data)
            .then(response => {
                // console.log(response)
                resolve(response.data.data);
            })
            .catch(error => {
                // console.log(error)
                reject(error);
            });
        })
    }

    /**
     * Clone a creative
     * @param {number} data - Creative Data to be inserted
     */
     this.cloneCreatives = (data) => {
        return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_ENDPOINT_CREATIVES_CLONE}`, data)
            .then(response => {
                // console.log(response)
                resolve(response.data.data);
            })
            .catch(error => {
                // console.log(error)
                reject(error);
            });
        })
    }

    /**
     * update a creative
     * @param {number} data - Creative Data to be inserted
     */
    this.updateCreative = (data) => {
        return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_ENDPOINT_CREATIVE_UPDATE}`, data)
            .then(response => {
                resolve(response.data.data);
            })
            .catch(error => {
                reject(error);
            });
        })
    }

    /**
     * delete a creative by id
     * @param {number} id - Creative ID
     */
    this.deleteCreative = (id) => {
        return new Promise((resolve, reject) => {
            axios.post(`${process.env.VUE_APP_ENDPOINT_CREATIVE_DELETE}${id}`)
                .then(response => {
                    if (response.data.status == 'ok') {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.data);
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    }

    /**
     * fetch a Airtory campaign 
     * @param {number} id - Campaign Id to be inserted
     */
    this.fetchAirtoryCampaign = (id) => {
        return new Promise((resolve, reject) => {
            axios.get(`${process.env.VUE_APP_ENDPOINT_AIRTORY_SYNC_CAMPAIGN}${id}?source=airtory`)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    console.log(error)
                    reject(error);
                });
        });
    }

    /**
     * fetch a Airtory Creative 
     * @param {number} id - Creative Id to be inserted
     */
    this.fetchAirtoryCreative = (id) => {
        return new Promise((resolve, reject) => {
            axios.get(`${process.env.VUE_APP_ENDPOINT_AIRTORY_SYNC_CREATIVE}${id}?source=airtory`)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    console.log(error)
                    reject(error);
                });
        });
    }

    /**
     * fetch a Airtory Placement 
     * @param {number} id - Placement Id to be inserted
     */
    this.fetchAirtoryPlacement = (id) => {
        return new Promise((resolve, reject) => {
            axios.get(`${process.env.VUE_APP_ENDPOINT_AIRTORY_SYNC_PLACEMENT}${id}`)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    console.log(error)
                    reject(error);
                });
        });
    }

    /**
     * fetch a Airtory Tag 
     * @param {number} id - Tag Id to be inserted
     */
    this.fetchAirtoryTag = (id) => {
        return new Promise((resolve, reject) => {
            axios.get(`${process.env.VUE_APP_ENDPOINT_AIRTORY_SYNC_TAG}${id}`)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    console.log(error)
                    reject(error);
                });
        });
    }

    /**
     * create a Creative events/s
     * @param {number} id - Creative Id to be inserted
     * @param {object or array} events - Creative Tracker/s events to be inserted
     */
    this.addCreativeEvents = (id, events) => {
        console.log('Data', id, events);
        return new Promise((resolve, reject) => {
            axios.post(`${process.env.VUE_APP_ENDPOINT_CREATIVE_ADD_EVENTS}${id}/events`, events)
                .then(response => {
                    // resolve(events);
                    // console.log('response', response)
                    resolve(response.data.data);
                })
                .catch(error => {
                    console.log(error)
                    reject(error);
                });
        })
    }

    /**
     * remove a Creative events/s
     * @param {number} id - Creative Id to be inserted
     * @param {object or array} events - Creative Tracker/s events to be inserted
     */
    this.removeCreativeEvents = (id, event) => {
        // console.log('Event api',  id, event);
        return new Promise((resolve, reject) => {
            axios.delete(`${process.env.VUE_APP_ENDPOINT_CREATIVE_DELETE_EVENTS}${id}/events/${event.creative_event_id}`)//, { data: { events }})
                .then(response => {
                    // resolve(events);
                    // console.log('response', response)
                    resolve(response.data.data);
                })
                .catch(error => {
                    console.log(error)
                    reject(error);
                });
        })
    }

    /**
     * create a Creative events/s
     * @param {number} id - Creative Id to be inserted
     * @param {object or array} events - Creative Tracker/s events to be inserted
     */
    this.updateCreativeEvents = (id, events) => {
        return new Promise((resolve, reject) => {
            axios.put(`${process.env.VUE_APP_ENDPOINT_CREATIVE_UPDATE_EVENTS}${id}/events`, events)
                .then(response => {
                    // resolve(events);
                    resolve(response.data.data);
                })
                .catch(error => {
                    console.log(error)
                    reject(error);
                });
        })
    }

    /**
     * create creatives log
     * @param {number} data - Creative Data to be inserted
     */
    this.createCreativesLogs = (data) => {
        return new Promise((resolve, reject) => {
            axios.post(`${process.env.VUE_APP_ENDPOINT_CREATIVES_CREATE_LOGS}`, data)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    console.log(error)
                    reject(error);
                });
        })
    }

     /**
     * return creatives upload logs by creative id
     * @param {number} id - Creative ID
     */
      this.fetchCreativesLogs = (id) => {
        return new Promise((resolve, reject) => {
            axios.get(`${process.env.VUE_APP_ENDPOINT_CREATIVES_GET_LOGS}${id}`)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    console.log(error)
                    reject(error);
                });
        })
    }

    /**
     * Download a creative by id
     * @param {number} id - Creative ID
     */
     this.fetchCreativesDownload = (id) => {
        return new Promise((resolve, reject) => {
            axios.get(`${process.env.VUE_APP_ENDPOINT_AIRTORY_CREATIVES_DOWNLOAD}${id}`)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    /**
     * returns data from a creative
     * @param {number} creativeId - User ID
     */
        this.getCreativeGwdFiles = (id) => {
        return new Promise((resolve, reject) => {
            axios.get(`${process.env.VUE_APP_ENDPOINT_CREATIVES_GET_GWD_FILES}${id}`)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    console.log(error)
                    reject(error);
                });
        })
    }

    /**
     * return live poll list
     */
    this.getLivePollList = () => {
        return new Promise((resolve, reject) => {
        axios.get(`${process.env.VUE_APP_ENDPOINT_LIVE_POLL_LIST}`)
            .then(response => {
            resolve(response.data.data)
            })
            .catch(error => {
            reject(error)
            })
        })
    }
    /**
     * return live poll by id
     * @param {number} id - feed ID
     */
    this.getLivePollById = (id) => {
        return new Promise((resolve, reject) => {
        axios.get(`${process.env.VUE_APP_ENDPOINT_LIVE_POLL_BY_ID}${id}`)
            .then(response => {
            resolve(response.data.data)
            })
            .catch(error => {
            reject(error)
            })
        })
    }
    /**
     * create a live poll
     * @param {object} data - Live Poll Data to be inserted
     */
    this.createLivePoll = (data) => {
        return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_ENDPOINT_LIVE_POLL_CREATE}`, data)
            .then(response => {
            resolve(response.data)
            })
            .catch(error => {
            reject(error)
            })
        })
    }
    /**
     * update a live poll
     * @param {object} data - 
     */
    this.updateLivePoll = (data) => {
        return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_ENDPOINT_LIVE_POLL_UPDATE}`, data)
            .then(response => {
            resolve(response.data)
            })
            .catch(error => {
            reject(error)
            })
        })
    }
    /**
     * delete a Live Poll
     * @param {number} id - Location Feeder ID
     */
    this.deleteLivePoll = function(id) {
        return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_ENDPOINT_LIVE_POLL_DELETE}${id}`)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                console.log(error)
                reject(error)
            })
        })
    }

}

export default new ApiCreativeProduction();